import React from 'react';
import { Container, Row, Col,Card , CardHeader,CardBody,FormInput,Button,FormSelect
	 } from "shards-react";
import PageTitle from "../common/PageTitle";
import SelectGroup from "../SelectGroup";
import {view} from 'react-easy-state';
import { AtomSpinner } from 'react-epic-spinners';
import AlertBox from '../AlertBox';
import lean_data from './leanStore';



export default view(()=>{
    return <MarkLean isLoading={lean_data.isLoading} />
})


class MarkLean extends React.Component{
    render(){
        return(
        <div>
            <AlertBox></AlertBox>
        <Container fluid className="main-content-container px-4 pb-4">
        {/* Page Header */}
        <Row noGutters className="page-header py-4">
              <PageTitle sm="4" title="Mark Customers As Lean" subtitle="Lean" className="text-sm-left" />
        </Row>

        
        <Col lg="12">
            <Card small className="mb-4">
                <CardHeader className="border-bottom">
                    <h6 className="m-0">Mark Lean</h6>
                </CardHeader>
                <CardBody>
                    <Col>
                    {   (!this.props.isLoading) &&
                    <div>
                        <Row>
                            <Col lg="4">
                                <label>Group</label>
                                <SelectGroup onChange={(evt)=>{lean_data.setGroupId(evt.target.value)}}/>
                            </Col>
                                <Input field="Ticket No." placeholder="Ticket No." type="number" onChange={(evt)=>{lean_data.setTicketNo(evt.target.value)}}/>
                                <SelectLeanType onChange={(evt)=>lean_data.setType(evt.target.value)} />
                        </Row>
                        <Row>
                            <Col lg="4"></Col>
                            <Col lg="4"><Button size="md" style={{maxWidth:'100%',width:'100%'}} onClick={()=>{lean_data.markLean()}}>Make Lean</Button></Col>
                            <Col lg="4"></Col>
                        </Row>
                        
                    </div>
                    }
                    {
                        this.props.isLoading &&
                        <center><AtomSpinner color={"blue"} /></center>
                    }
                    </Col>
                </CardBody>
            </Card>
        </Col>
        </Container>
    </div>
        )
    }
}


class Input extends React.Component{
    render(){
        return(
            <Col md="4" lg="4" className="form-group">
                <label htmlFor="feEmailAddress">{this.props.field}</label>
                <FormInput
                  {...this.props}
                />
            </Col>
        )
    }
}


function SelectLeanType(props){
    return(
        <Col lg="4" md="4">
        <label>Mark/Unmark</label>
        <FormSelect onChange ={props.onChange}>
                <option value="mark">Mark</option>
                <option value="unmark">UnMark</option>
        </FormSelect>
        </Col>
    )
}